import createPromiseSaga from 'lib/createPromiseSaga';
import getIn from '@alexaivars/get-in';
import normalizingFetch from 'lib/normalizingFetch';
import { LOAD_MORE_NEWS, READ_STORY_STREAM } from './actions';
import { all, take, actionChannel } from 'redux-saga/effects';

export function* watchStoryStream() {
  const channel = yield actionChannel(READ_STORY_STREAM);
  while (true) {
    const action = yield take(channel);

    const siteCode = getIn(action, ['payload', 'siteCode'], 'com');
    let sites = undefined;

    if (siteCode === 'dach') {
      sites = ['de', 'at', 'ch'];
    } else if (siteCode !== 'com') {
      sites = [siteCode];
    }

    yield* createPromiseSaga(
      action,
      normalizingFetch,
      `${process.env.REACT_APP_API_TOP_NEWS}`,
      {
        detailedResponse: true,
        method: 'POST',
        body: {
          // TODO: Change the API to a GET endpoint and accept the sites as
          // one of the following options header, query param or part of the
          // path. This would be more semantic and simplify endpoint caching.
          sites,
        },
      },
    )();
  }
}

export function* watchLoadMoreNews() {
  const channel = yield actionChannel(LOAD_MORE_NEWS);

  while (true) {
    const action = yield take(channel);
    yield* createPromiseSaga(
      action,
      normalizingFetch,
      getIn(action, ['payload', 'link']),
      {
        detailedResponse: true,
        method: 'POST',
      },
    )();
  }
}

export default function* sagas(i18n) {
  yield all([watchStoryStream(), watchLoadMoreNews()]);
}
